import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import { Container, Button } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchArticles } from '../modules/ArticleList/actions';
import { isLoaded, getError } from '../modules/ArticleList/reducer';
import ArticleList from '../modules/ArticleList';

class ArticleListPage extends Component {
  componentDidMount() {
    this.props.fetchArticles();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Články</h1>
            <Button tag={Link} to="/clanky/new" color="primary">
              Nový článek
            </Button>
          </PageNav>
          <Loader loaded={isLoaded}>
            <ArticleList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchArticles }
)(ArticleListPage);



// WEBPACK FOOTER //
// ./src/pages/ArticleListPage.js